import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../utils';
import { DataTableRow } from '../DataTable/DataTableRow';
import { DataTableRowContent } from '../DataTable/DataTableRowContent';
import { DataTableRowHeader } from '../DataTable/DataTableRowHeader';
import { Link } from '../Link';
export function DataTableListItem({ headerTitle, headerTags, contentData, handleSelect, }) {
    return (_jsx(DataTableRow, { striped: false, children: _jsxs(LinkStyled, { onClick: handleSelect, children: [_jsx(DataTableRowHeader, { title: headerTitle, tags: headerTags, editable: false, gapBottom: true }), _jsx(DataTableRowContent, { data: contentData, maxColumns: 1, rowGap: 1 })] }) }));
}
const LinkStyled = styled(Link)(() => ({
    cursor: 'pointer',
}));
